"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var INITIAL_WORDS_COUNT = 20;
var WorksheetVocabWrapper = function WorksheetVocabWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "showFilterOptions", _descriptor, _this);
      _initializerDefineProperty(_this, "filterCache", _descriptor2, _this);
      _initializerDefineProperty(_this, "sortCache", _descriptor3, _this);
      _initializerDefineProperty(_this, "allWordsLoaded", _descriptor4, _this);
      _this.getWorksheetWords = function (worksheetId) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _state.ExerciseUI.worksheetWordStore.clearFilter();
        if (params.clearIndex) {
          _state.ExerciseUI.worksheetWordStore.clearIndexData();
          _this.allWordsLoaded = false;
          _state.ExerciseUI.worksheetWordStore.limit = INITIAL_WORDS_COUNT;
        }
        _state.ExerciseUI.worksheetWordStore.setPage(1);
        if (params.fetchAll) {
          _state.ExerciseUI.worksheetWordStore.getIndex({
            ids: {
              worksheetId: worksheetId
            },
            limit: _state.ExerciseUI.worksheet.worksheetWordsCount,
            filters: _this.filters,
            sort: _this.vocabSort
          }, function (resp) {
            _state.ExerciseUI.worksheetWordStore.setIndexData(resp);
            _this.allWordsLoaded = true;
          });
          return;
        }
        _state.ExerciseUI.worksheetWordStore.getIndex({
          ids: {
            worksheetId: worksheetId
          },
          limit: INITIAL_WORDS_COUNT,
          filters: _this.filters,
          sort: _this.vocabSort
        }, function (resp) {
          var _resp$meta, _resp$data;
          _state.ExerciseUI.worksheetWordStore.setIndexData(resp);
          var totalCount = (resp === null || resp === void 0 || (_resp$meta = resp.meta) === null || _resp$meta === void 0 ? void 0 : _resp$meta.totalCount) || 0;
          var loadedCount = (resp === null || resp === void 0 || (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.length) || 0;
          _this.allWordsLoaded = loadedCount >= totalCount;
        });
      };
      _this.loadRemainingWords = function (worksheetId) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var totalCount = _state.ExerciseUI.worksheetWordStore.totalCount || _state.ExerciseUI.worksheet.worksheetWordsCount;
        if (totalCount > INITIAL_WORDS_COUNT) {
          _state.ExerciseUI.worksheetWordStore.setPage(1);
          _state.ExerciseUI.worksheetWordStore.getIndex({
            ids: {
              worksheetId: worksheetId
            },
            limit: totalCount,
            filters: _this.filters,
            sort: _this.vocabSort,
            queryStrings: {
              offset: INITIAL_WORDS_COUNT
            }
          }, function (resp) {
            _state.ExerciseUI.worksheetWordStore.setIndexData(resp, {
              addToIndexData: true
            });
            _this.allWordsLoaded = true;
            if (params !== null && params !== void 0 && params.callback) params.callback(resp);
          });
        }
      };
      _this.setShowFilterOptions = function (showFilterOptions) {
        _this.showFilterOptions = showFilterOptions;
      };
      _this.filterCacheOrCookie = function (field) {
        if (field in _this.filterCache) {
          return _this.filterCache[field].join(',');
        }
        return _state.ExerciseUI.getCookieValue(field);
      };
      _this.arrayToOptions = function (object, field) {
        return object.map(function (item) {
          return [item.id, item[field]];
        });
      };
      _this.keyIsMultiSelect = function (key) {
        var _this$filterSettings$;
        return (_this$filterSettings$ = _this.filterSettings.find(function (item) {
          return item.userKey === key;
        })) === null || _this$filterSettings$ === void 0 ? void 0 : _this$filterSettings$.multiSelect;
      };
      _this.isSelected = function (userKey, value) {
        var _this$filterSettings$2, _this$filters$key;
        var key = (_this$filterSettings$2 = _this.filterSettings.find(function (item) {
          return item.userKey === userKey;
        })) === null || _this$filterSettings$2 === void 0 ? void 0 : _this$filterSettings$2.key;
        return _this.filters[key] && (0, _utils.isPresent)((_this$filters$key = _this.filters[key]) === null || _this$filters$key === void 0 ? void 0 : _this$filters$key.split(',').find(function (item) {
          return item === value;
        }));
      };
      _this.onSetFilter = function (key, value, params) {
        _state.VocabUI.allToggleSelected = false;
        var multiSelect = _this.keyIsMultiSelect(key);
        if (multiSelect) {
          _this.updateMultipleSelectFilter(key, value);
        } else {
          _this.filterCache[key] = value;
        }
        var callback = !params || !params['skipGetWords'] ? function () {
          return _this.getWorksheetWords(_state.ExerciseUI.worksheetId, {
            fetchAll: true,
            clearIndex: true
          });
        } : _lodash.noop;
        var data = {};
        data[key] = multiSelect ? _this.filterCache[key].join(',') : value;
        _this.updateUserGroup(data, callback);
      };
      _this.onSetSort = function (value) {
        _this.sortCache = value;
        _state.AppUI.cookieStore.set('vocabSort', value);
        _this.getWorksheetWords(_state.ExerciseUI.worksheetId, {
          fetchAll: true,
          clearIndex: true
        });
      };
      _this.onToggleSort = function () {
        if (!(0, _utils.isPresent)(_this.vocabSort)) return;
        if (_this.vocabSort.startsWith('-')) {
          _this.onSetSort(_this.vocabSort.replace(/^-/, ''));
        } else {
          _this.onSetSort("-".concat(_this.vocabSort));
        }
      };
      _this.updateMultipleSelectFilter = function (key, value) {
        var cookieValue = _state.ExerciseUI.getCookieValue(key);
        if ((0, _utils.isBlank)(value) || !cookieValue) {
          _this.filterCache[key] = [];
        } else if ((0, _utils.isBlank)(_this.filterCache[key]) && (0, _lodash.isString)(cookieValue)) {
          _this.filterCache[key] = cookieValue.split(',');
        } else if ((0, _utils.isBlank)(_this.filterCache[key])) {
          _this.filterCache[key] = [];
        }
        _this.filterCache[key] = (0, _lodash.xor)(_this.filterCache[key], [value]);
      };
      _this.updateUserGroup = function (data, callback) {
        (0, _lodash.each)((0, _lodash.keys)(data), function (key) {
          _state.ExerciseUI.setCookieValue(key, data[key]);
        });
        if (callback) {
          callback();
        }
      };
      _this.onPagination = function () {
        _state.VocabUI.allToggleSelected = false;
      };
      _this.onCreateReviews = function () {
        _state.VocabUI.onCreateReviews({
          languageId: _state.ExerciseUI.languageId,
          interfaceSource: "worksheet".concat((0, _utils.isPresent)(_state.ExerciseUI.userGroup) && (0, _utils.isPresent)(_state.ExerciseUI.userGroup.name) ? "-".concat(_state.ExerciseUI.userGroup.name.toLowerCase().split(' ').join('-')) : '')
        });
        _state.AppUI.set('reloadReviewDecks', true);
      };
      _this.selectedCardTypeIsCompatible = function (word) {
        if (_state.VocabUI.cardTypeId === undefined) {
          return true;
        }
        switch (_constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
          return item.id === _state.VocabUI.cardTypeId;
        }).slug) {
          case 'conjugation':
            return word.isVerb && !word.hideFromConjugationTrainer;
          case 'gender':
            return word.isNoun && !word.hideFromGenderTrainer;
          case 'plural':
            return word.isNoun && !word.hideFromPluralTrainer && !word.noPlural && word.languageId === 'DE';
          default:
            return true;
        }
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "sortOptions",
      get: function get() {
        var _AppUI$site, _AppUI$site2, _AppUI$site3, _AppUI$site4;
        var options = [];
        if ((_AppUI$site = _state.AppUI.site) !== null && _AppUI$site !== void 0 && _AppUI$site.showChronologicalSort && _state.ExerciseUI.worksheet.positionsAreChronological) {
          options.push({
            label: 'Chronologically',
            value: 'position'
          });
        }
        if ((_AppUI$site2 = _state.AppUI.site) !== null && _AppUI$site2 !== void 0 && _AppUI$site2.showAlphabeticalSort) {
          options.push({
            label: 'Alphabetically',
            value: 'translations.target_text'
          });
        }
        if ((_AppUI$site3 = _state.AppUI.site) !== null && _AppUI$site3 !== void 0 && _AppUI$site3.showLevelSort) {
          options.push({
            label: 'By Level',
            value: 'translations.level_abbreviation'
          });
        }
        if ((_AppUI$site4 = _state.AppUI.site) !== null && _AppUI$site4 !== void 0 && _AppUI$site4.showFrequencySort) {
          options.push({
            label: 'By Frequency',
            value: 'translations.frequency_ranking'
          });
        }
        return options;
      }
    }, {
      key: "hasActiveFilter",
      get: function get() {
        return (0, _utils.isPresent)(this.filterSettings.filter(function (item) {
          return !item.hide && (0, _utils.isPresent)(item.value);
        }));
      }
    }, {
      key: "vocabSort",
      get: function get() {
        var _this$sortOptions$;
        if (this.sortCache) return this.sortCache;
        var sortFromCookie = _state.AppUI.cookieStore.vocabSort;
        if (!sortFromCookie || !this.sortOptions) return null;
        if (this.sortOptions.some(function (item) {
          return sortFromCookie === null || sortFromCookie === void 0 ? void 0 : sortFromCookie.includes(item.value);
        })) {
          return sortFromCookie;
        }
        return (_this$sortOptions$ = this.sortOptions[0]) === null || _this$sortOptions$ === void 0 ? void 0 : _this$sortOptions$.value;
      }
    }, {
      key: "filterWordTypes",
      get: function get() {
        var wordTypes = (0, _lodash.clone)(_constants.Constants.VOCAB_WORD_TYPES);
        wordTypes.push({
          id: '0c228a45-ec30-4a0d-8c94-c88129e3c38b',
          name: 'Phrase'
        });
        return (0, _lodash.sortBy)(wordTypes, function (item) {
          return item.name;
        });
      }
    }, {
      key: "filterSettings",
      get: function get() {
        var _AppUI$site5,
          _AppUI$site6,
          _this2 = this;
        var settings = [];
        if ((_AppUI$site5 = _state.AppUI.site) !== null && _AppUI$site5 !== void 0 && _AppUI$site5.showLevelFilter) {
          settings.push({
            key: 'translations.level_id',
            userKey: 'vocabLevelId',
            label: 'Level',
            multiSelect: true,
            includeBlank: true,
            options: this.arrayToOptions(_constants.Constants.LEVELS.filter(function (item) {
              return item.abbreviation !== 'N';
            }), 'abbreviation'),
            filterType: 'select'
          });
        }
        if ((_AppUI$site6 = _state.AppUI.site) !== null && _AppUI$site6 !== void 0 && _AppUI$site6.showWordTypeFilter) {
          settings.push({
            key: 'translations.word_type_id',
            userKey: 'vocabWordTypeId',
            label: 'Word Type',
            multiSelect: true,
            includeBlank: true,
            options: this.arrayToOptions(this.filterWordTypes, 'name'),
            filterType: 'select'
          });
        }
        return settings.map(function (item) {
          var hsh = {
            tagDisplay: (0, _utils.formatFilterTag)(item, _this2.filterCacheOrCookie(item.userKey)),
            value: _this2.filterCacheOrCookie(item.userKey)
          };
          return (0, _lodash.merge)(item, hsh);
        });
      }
    }, {
      key: "selectedSortLabel",
      get: function get() {
        var _this$sortOptions$fin,
          _this3 = this;
        return (0, _utils.isPresent)(this.vocabSort) && ((_this$sortOptions$fin = this.sortOptions.find(function (item) {
          var _this3$vocabSort;
          return (_this3$vocabSort = _this3.vocabSort) === null || _this3$vocabSort === void 0 ? void 0 : _this3$vocabSort.includes(item.value);
        })) === null || _this$sortOptions$fin === void 0 ? void 0 : _this$sortOptions$fin.label);
      }
    }, {
      key: "sortOrder",
      get: function get() {
        if ((0, _utils.isPresent)(this.vocabSort) && this.vocabSort.startsWith('-')) {
          return 'up';
        } else {
          return 'down';
        }
      }
    }, {
      key: "filters",
      get: function get() {
        var filters = {};
        (0, _lodash.each)(this.filterSettings.filter(function (item) {
          return (0, _utils.isPresent)(item.value);
        }), function (item) {
          filters[item.key] = item.filterValue || item.value;
        });
        return filters;
      }
    }, {
      key: "noFiltersSelectedMessage",
      get: function get() {
        return 'No Filter Selected.';
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          setShowFilterOptions: this.setShowFilterOptions,
          showFilterOptions: this.showFilterOptions,
          noFiltersSelectedMessage: this.noFiltersSelectedMessage,
          filterSettings: this.filterSettings,
          onSetFilter: this.onSetFilter,
          hasActiveFilter: this.hasActiveFilter,
          getWorksheetWords: this.getWorksheetWords,
          loadRemainingWords: this.loadRemainingWords,
          allWordsLoaded: this.allWordsLoaded,
          filters: this.filters,
          sortOrder: this.sortOrder,
          onToggleSort: this.onToggleSort,
          sortOptions: this.sortOptions,
          vocabSort: this.vocabSort,
          selectedSortLabel: this.selectedSortLabel,
          onSetSort: this.onSetSort,
          selectedWordIds: _state.VocabUI.selectedWordIds,
          selectedWords: _state.VocabUI.selectedWords,
          onToggleAddWordToDeck: function onToggleAddWordToDeck(word) {
            return _state.VocabUI.onToggleAddWordToDeck(word, {
              alwaysAllow: true
            });
          },
          onToggleAddAllToDeck: _state.VocabUI.onToggleAddAllToDeck,
          onPagination: this.onPagination,
          allToggleSelected: _state.VocabUI.allToggleSelected,
          cardTypeOptions: _state.VocabUI.cardTypeOptions,
          cardTypeId: _state.VocabUI.cardTypeId,
          onSetCardTypeId: _state.VocabUI.onSetCardTypeId,
          onCreateReviews: this.onCreateReviews,
          deckButtonDisabled: _state.VocabUI.deckButtonDisabled,
          selectedWordsExcludedFromGenderTrainer: _state.VocabUI.selectedWordsExcludedFromGenderTrainer,
          selectedWordsExcludedFromPluralTrainer: _state.VocabUI.selectedWordsExcludedFromPluralTrainer,
          selectedWordsExcludedFromConjugationTrainer: _state.VocabUI.selectedWordsExcludedFromConjugationTrainer,
          selectedCardTypeIsCompatible: this.selectedCardTypeIsCompatible,
          deckId: _state.VocabUI.deckId,
          onSetDeckId: _state.VocabUI.onSetDeckId,
          createReviewsFinished: _state.VocabUI.createReviewsFinished,
          createReviewsIsSlow: _state.VocabUI.createReviewsIsSlow
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showFilterOptions", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "filterCache", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return {};
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "sortCache", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "allWordsLoaded", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "sortOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sortOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasActiveFilter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasActiveFilter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "vocabSort", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "vocabSort"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filterWordTypes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filterWordTypes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filterSettings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedSortLabel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedSortLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sortOrder", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sortOrder"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filters"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "noFiltersSelectedMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "noFiltersSelectedMessage"), _class2.prototype), _class2)) || _class;
};
WorksheetVocabWrapper.displayName = 'WorksheetVocabWrapper';
var _default = exports["default"] = WorksheetVocabWrapper;